module.exports = require("core-js/library/fn/map");


//////////////////
// WEBPACK FOOTER
// ./~/@babel/runtime/core-js/map.js
// module id = 114
// module chunks = 35783957827783 114276838955818 162898551421021